import { memo } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { getRoomPdf } from '../../utils/api';

const RoomCard = ({ room }) => {
  const { removeRoom } = useApp();

  const handlePdf = async () => {
    const blob = await getRoomPdf(room._id);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${room.name.replace(/[^a-z0-9]/gi, '_')}_summary.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="card room-card">
      <div className="card-header">
        <h3>{room.name}</h3>
        <div className="badges">
          <span className="badge">{room.floor} floor</span>
          <span className="badge badge-room-type">{room.roomType}</span>
        </div>
      </div>

      <div className="room-paint-row">
        {room.wallPaintColor && (
          <div className="paint-chip-group">
            <span className="paint-label">Walls</span>
            <span className="paint-value">{room.wallPaintColor}</span>
            {room.wallPaintBrand && <span className="paint-brand">{room.wallPaintBrand}</span>}
          </div>
        )}
        {room.trimColor && (
          <div className="paint-chip-group">
            <span className="paint-label">Trim</span>
            <span className="paint-value">{room.trimColor}</span>
          </div>
        )}
        {room.ceilingColor && (
          <div className="paint-chip-group">
            <span className="paint-label">Ceiling</span>
            <span className="paint-value">{room.ceilingColor}</span>
          </div>
        )}
      </div>

      <div className="card-meta">
        {room.squareFootage && <span>{room.squareFootage} sq ft</span>}
        {room.flooringType && <span>Flooring: {room.flooringType}</span>}
        {room.outlets?.length > 0 && <span>{room.outlets.length} outlet{room.outlets.length !== 1 ? 's' : ''}</span>}
        {room.hvacVents?.length > 0 && <span>{room.hvacVents.length} HVAC vent{room.hvacVents.length !== 1 ? 's' : ''}</span>}
      </div>

      <div className="card-actions">
        <Link to={`/rooms/${room._id}/edit`} className="btn btn-secondary">Edit</Link>
        <button className="btn btn-secondary" onClick={handlePdf}>PDF</button>
        <button className="btn btn-danger" onClick={() => removeRoom(room._id)}>Delete</button>
      </div>
    </div>
  );
};

export default memo(RoomCard);
